<section class="app-abo-us-bra" [id]="AboutUsSection.OUR_BRANDS">
  <div class="container app-abo-us-bra__con">
    <div class="app-abo-us-bra__con__rig">
      <h2 class="app-abo-us-bra__con__rig__h2">MARKI L'ORÉAL PROFESSIONAL PRODUCTS</h2>
      <ul class="list-unstyled app-abo-us-bra__con__rig__ul">
        <li class="app-abo-us-bra__con__rig__ul__li" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.5">
          <figure class="app-abo-us-bra__con__rig__ul__li__fig">
            <img
              class="app-abo-us-bra__con__rig__ul__li__fig__img ms-lg-5"
              [priority]="false"
              alt="kerastase"
              ngSrc="assets/images/kerastase.svg"
              width="121"
              height="34"
              [appAnimate]="'fadeIn'"
              [speed]="'fast'"
            />
            <figcaption class="app-abo-us-bra__con__rig__ul__li__fig__fig">
              <p class="app-abo-us-bra__con__rig__ul__li__fig__fig__p">
                Luksusowa marka znana ze swojego innowacyjnego podejścia do piękna i zdrowia włosów. Od ponad 60 lat
                buduje swoją reputację, oferując wyjątkową, luksusową pielęgnację– wspieraną nauką w połączeniu z
                profesjonalnym doświadczeniem najlepszych fryzjerów na świecie. Kérastase zapewnia wszystkim wymagającym
                włosom wysokiej jakości, spersonalizowane, luksusowe rozwiązania pielęgnacyjne.
              </p>
              <a
                class="app-abo-us-bra__con__rig__ul__li__fig__fig__a"
                [routerLink]="['/' + WwwRouteSlug.BRAND, Brand.KERASTASE]"
                appGtmClick
                [layer]="{
                  event: 'uaevent',
                  ecommerce: 'undefined',
                  eventCategory: 'about us page',
                  eventAction: 'select::show more kerastase',
                  eventLabel: 'show more kerastase::' + '/' + WwwRouteSlug.BRAND + Brand.KERASTASE,
                  event_name: 'body_button_click',
                  module_name: 'show more kerastase',
                  cta_name: 'show more kerastase',
                  link_url: '/' + WwwRouteSlug.BRAND + Brand.KERASTASE,
                }"
              >
                zobacz więcej
              </a>
            </figcaption>
          </figure>
        </li>
        <li
          class="app-abo-us-bra__con__rig__ul__li"
          [appAnimate]="'landing'"
          [speed]="'fast'"
          [aos]="0.5"
          [delay]="'200'"
        >
          <figure class="app-abo-us-bra__con__rig__ul__li__fig">
            <img
              class="app-abo-us-bra__con__rig__ul__li__fig__img ms-lg-5"
              [priority]="false"
              alt="loreal"
              ngSrc="assets/images/loreal.png"
              width="145"
              height="51"
              [appAnimate]="'fadeIn'"
              [speed]="'fast'"
            />
            <figcaption class="app-abo-us-bra__con__rig__ul__li__fig__fig">
              <p class="app-abo-us-bra__con__rig__ul__li__fig__fig__p">
                Wiodąca na świecie, ikoniczna marka dla stylistów fryzur współpracująca z ponad 1,5 mln fryzjerów na
                całym świecie. Oferuje profesjonalną edukację w koloryzacji, pielęgnacji i stylizacji, współpracując z
                uznanymi światowymi ekspertami. Wspiera fryzjerów w budowaniu pewności siebie i doskonaleniu rzemiosła,
                umożliwiając osiąganie mistrzowskiego poziomu.
              </p>
              <a
                class="app-abo-us-bra__con__rig__ul__li__fig__fig__a"
                [routerLink]="['/' + WwwRouteSlug.BRAND, Brand.LOREAL_PROFESSIONNEL]"
                appGtmClick
                [layer]="{
                  event: 'uaevent',
                  ecommerce: 'undefined',
                  eventCategory: 'about us page',
                  eventAction: 'select::show more loreal',
                  eventLabel: 'show more loreal::' + '/' + WwwRouteSlug.BRAND + Brand.LOREAL_PROFESSIONNEL,
                  event_name: 'body_button_click',
                  module_name: 'show more loreal',
                  cta_name: 'show more loreal',
                  link_url: '/' + WwwRouteSlug.BRAND + Brand.LOREAL_PROFESSIONNEL,
                }"
              >
                zobacz więcej
              </a>
            </figcaption>
          </figure>
        </li>
        <li
          class="app-abo-us-bra__con__rig__ul__li"
          [appAnimate]="'landing'"
          [speed]="'fast'"
          [aos]="0.5"
          [delay]="'400'"
        >
          <figure class="app-abo-us-bra__con__rig__ul__li__fig">
            <img
              class="app-abo-us-bra__con__rig__ul__li__fig__img ms-lg-5"
              [priority]="false"
              alt="redken"
              ngSrc="assets/images/redken.svg"
              width="137"
              height="36"
              [appAnimate]="'fadeIn'"
              [speed]="'fast'"
            />
            <figcaption class="app-abo-us-bra__con__rig__ul__li__fig__fig">
              <p class="app-abo-us-bra__con__rig__ul__li__fig__fig__p">
                Łączy nowatorskie technologie z praktycznymi warsztatami, wspierając fryzjerów w rozwijaniu umiejętności
                technicznych i kreatywności w koloryzacji, stylizacji i pielęgnacji włosów. Marka współpracuje z
                uznanymi ekspertami i edukatorami, inspirując do samorozwoju oraz tworzenia innowacyjnych stylizacji, co
                zapewnia profesjonalistom lepsze zrozumienie produktów i technik pracy.
              </p>
              <a
                class="app-abo-us-bra__con__rig__ul__li__fig__fig__a"
                [routerLink]="['/' + WwwRouteSlug.BRAND, Brand.REDKEN]"
                appGtmClick
                [layer]="{
                  event: 'uaevent',
                  ecommerce: 'undefined',
                  eventCategory: 'about us page',
                  eventAction: 'select::show more redken',
                  eventLabel: 'show more redken::' + '/' + WwwRouteSlug.BRAND + Brand.REDKEN,
                  event_name: 'body_button_click',
                  module_name: 'show more redken',
                  cta_name: 'show more redken',
                  link_url: '/' + WwwRouteSlug.BRAND + Brand.REDKEN,
                }"
              >
                zobacz więcej
              </a>
            </figcaption>
          </figure>
        </li>
        <li
          class="app-abo-us-bra__con__rig__ul__li"
          [appAnimate]="'landing'"
          [speed]="'fast'"
          [aos]="0.5"
          [delay]="'600'"
        >
          <figure class="app-abo-us-bra__con__rig__ul__li__fig">
            <img
              class="app-abo-us-bra__con__rig__ul__li__fig__img"
              [priority]="false"
              alt="matrix"
              ngSrc="assets/images/matrix.webp"
              width="235"
              height="103"
              [appAnimate]="'fadeIn'"
              [speed]="'fast'"
            />
            <figcaption class="app-abo-us-bra__con__rig__ul__li__fig__fig">
              <p class="app-abo-us-bra__con__rig__ul__li__fig__fig__p">
                Edukacja dostosowana do potrzeb współczesnych fryzjerów. Warsztaty stacjonarne w centrach szkoleniowych
                łączą teorię z praktyką, zapewniając bezpośrednią pracę z produktami Matrix. Szkolenia na żywo przez
                Teams pozwalają na interakcję z Edukatorami i wymianę doświadczeń. Platforma Access umożliwia dostęp do
                szkoleń przez całą dobę, obejmując techniki koloryzacji, strzyżenia oraz wiedzę produktową.
              </p>
            </figcaption>
          </figure>
        </li>
      </ul>
    </div>
  </div>
</section>
